var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// var Popper = require('popper.js');
// window.Popper = Popper;
require('moment');
// require('bootstrap');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
require('bootstrap/js/dist/util');
require('bootstrap/js/dist/collapse');
// require('bootstrap/js/dist/dropdown');
// require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
require('bootstrap/js/dist/scrollspy');
// require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

// require('bootstrap-select');
// require('bootstrap-datepicker');
// require('bootstrap-material-design');




// require('jquery-sticky');

require('owl.carousel');
// require('magnific-popup');
// require('isotope-layout/dist/isotope.pkgd');
// require('imagesloaded');
const WOW = require('wow.js');


// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded




$(function() {


    if ($(window).width() >= 768) {
    //wow.js animations
    new WOW().init({});
    }

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }



    $('#btn-mob-nav').on('click', function() {
        $('#mob-nav').fadeIn('slow');
    });

    $('#btn-mob-nav-close').on('click', function() {
        $('#mob-nav').fadeOut('slow');
    })

    $('.page-scroll').on('click', function() {
        $('#mob-nav').fadeOut('slow');
    })


    if ($('.main-slider').length) {
        $('.main-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: true,
            dots: true,
            autoplay: true,
            autoplayTimeout: 7000,
            smartSpeed: 1000,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            responsive: {

                992: {
                    nav: true,
                }
            }

        })
    }

    if ($('.testimonial-carousel').length) {
        $('.testimonial-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 12000,
            smartSpeed: 750,
            responsive: {

                992: {
                    items: 2,
                    margin: 42,
                },
                1200: {
                    items: 2,
                    margin: 42,
                },
                1600: {
                    items: 3,
                    margin: 42,
                },
                2000: {
                    items: 4,
                    dots: true,
                    margin: 42,
                }
            }

        })
    }

    function scrollToEl(elId) {
        elId = elId.replace(/_$/, '');
        if ($(window).width() <= 768) {
            $('html, body').stop().animate({
                scrollTop: $(elId).offset().top - 55
            }, 1500, 'easeInOutExpo');
        } else {
            $('html, body').stop().animate({
                scrollTop: $(elId).offset().top - 135
            }, 1500, 'easeInOutExpo');
        }
    } 

    $('a.page-scroll').bind('click', function(event) {
        var $anchor = $(this);
        var elId = $anchor.attr('href').replace(/^\//, '');
        scrollToEl(elId);
        event.preventDefault();
    });
    var hash = window.location.hash;
    if (hash) {
        scrollToEl(hash);
    }

    // $('a[href]').click(function (e) {
    //     e.preventDefault();

    //     var navHeight = $('.main-nav').height();
    //     var id = $(this).attr('rel');
    //     var scrollTo = $('#' + id).offset().navHeight;

    //     $('html,body').animate({
    //         'scrollTop': scrollTo
    //     }, 500);
    // });

    $('body').scrollspy({
        target: '#main-nav',
        offset: 140
    })

    setTimeout(scrollToFormError, 1000);
})

// scroll window to form error element and offset fixed header height
function scrollToFormError() {
    // console.log('scrollToFormError', window.location.hash);
    var windowWidth = $(window).width();
    var formStr = '#_form-';
    // enquiry form error anchor offset

    if (window.location.hash && window.location.hash.indexOf(formStr) != -1) {

        var formEl = window.location.hash.replace('#_form-', '#form-');
        if ($(formEl).length > 0) {

            // console.log(window.location.hash+' '+offsetSize +' '+$(formEl).scrollTop());


            if (windowWidth > 992) {
                var offsetSize = $('#header').height() + 150;
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            } else {
                var offsetSize = $('#header').height() + 150;
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            }
        }
    }
}

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {


}


// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js